"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  /**
   * copy-paste from sentry docs
   */

  // This is technically redundant since we handle errors at a component level
  // It's here as a safety net in case we miss something
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* Next.js error component doesn't allow omitting statusCode yet */}
        <NextError statusCode={undefined as never} />
      </body>
    </html>
  );
}
